import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-success" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Getting estimates from nearby shops. We'll notify you when they're ready. ")
], -1)
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "alert alert-success" }
const _hoisted_6 = { class: "estimate-list__spacing" }
const _hoisted_7 = { class: "estimate-list__header d-flex justify-content-between flex-wrap" }
const _hoisted_8 = { class: "sort-buttons" }
const _hoisted_9 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "estimate-padding" }
const _hoisted_12 = {
  key: 1,
  class: "h2"
}
const _hoisted_13 = {
  key: 1,
  class: "map-bg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Placeholder = _resolveComponent("Placeholder")!
  const _component_NoOffersAvailable = _resolveComponent("NoOffersAvailable")!
  const _component_icon = _resolveComponent("icon")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_OfferPartial = _resolveComponent("OfferPartial")!
  const _component_OfferMap = _resolveComponent("OfferMap")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([{ row: _ctx.showMap }, "estimate-list-container offer-selector"])
  }, [
    (!_ctx.isAdminFlow)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "Compare estimates and select a shop."))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["estimate-list__col", {'col-sm-12': _ctx.showMap}])
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_Transition, { key: 0 }, {
            default: _withCtx(() => [
              (!_ctx.autoquotable)
                ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_Placeholder, { amount: 5 })
                  ]))
                : (_ctx.isZeroOffer)
                  ? (_openBlock(), _createBlock(_component_NoOffersAvailable, {
                      key: 1,
                      zipcode: _ctx.serviceRequest.zipcode
                    }, null, 8, ["zipcode"]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_icon, { icon: ['fal', 'info-circle'] }),
                          _createTextVNode(" Your estimates should arrive within 30 seconds.")
                        ])
                      ]),
                      _createVNode(_component_Placeholder, { amount: 5 })
                    ]))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_Transition, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_6, [
                _createElementVNode("header", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary btn-map px-3 mb-2 d-none",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMap(!_ctx.showMap)))
                  }, [
                    _createVNode(_component_icon, {
                      icon: ['fas', 'map'],
                      class: "mr-2"
                    }),
                    (!_ctx.showMap)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Show")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Hide")
                        ], 64)),
                    _createTextVNode(" Map ")
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortButtons, (button) => {
                        return (_openBlock(), _createElementBlock("button", {
                          type: "button",
                          class: "btn btn-tertiary",
                          onClick: ($event: any) => (_ctx.selectedSort = button.value),
                          key: `k-${button.value}`
                        }, _toDisplayString(button.text), 9, _hoisted_10))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Retrieving your estimates..."))
                    : (_openBlock(), _createBlock(_TransitionGroup, {
                        key: 2,
                        name: "list",
                        tag: "ul",
                        class: "list-group list-group-flush estimate-list"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offersSorted, (offer) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `offer-${offer.id}`,
                              class: "list-group-item estimate-list__items d-flex flex-column"
                            }, [
                              _createVNode(_component_OfferPartial, {
                                ref_for: true,
                                ref: `offer-${offer.openbayId}`,
                                offer: offer,
                                services: _ctx.serviceRequest.services,
                                onShowMap: _ctx.toggleMap
                              }, null, 8, ["offer", "services", "onShowMap"])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                ])
              ])
            ]),
            _: 1
          }))
    ], 2),
    (_ctx.showMap)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_OfferMap, {
            lat: _ctx.serviceRequest.lat,
            lon: _ctx.serviceRequest.lon,
            offers: _ctx.offers,
            onShowLocationDetails: _ctx.showLocationDetails,
            onShowMap: _ctx.toggleMap
          }, null, 8, ["lat", "lon", "offers", "onShowLocationDetails", "onShowMap"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}